import {Dialog} from 'quasar';
import {defineAsyncComponent} from 'vue';
import PlaceTokens from '@/utils/constants/PlaceTokens.ts';

const WizardFieldsSelectorDialog = defineAsyncComponent(
  () => import('@/components/dialogs/wizardEditors/WizardFieldsSelectorDialog.vue')
);
const ReportExpressionEditorDialog = defineAsyncComponent(
  () => import('@/components/dialogs/wizardEditors/ReportExpressionEditorDialog.vue')
);
const ReportUnionHandlingEditorDialog = defineAsyncComponent(
  () => import('@/components/dialogs/wizardEditors/ReportUnionHandlingEditorDialog.vue')
);

interface ParsedPlace {
  token: string;
  params: Record<string, string>;
}

function parsePlaceUrl(url: string): ParsedPlace | null {
  const hashIdx = url.indexOf('#');
  if (hashIdx < 0) return null;
  const hash = url.substring(hashIdx + 1);
  const colonIdx = hash.indexOf(':');
  const token = colonIdx < 0 ? hash : hash.substring(0, colonIdx);
  const queryStr = colonIdx < 0 ? '' : hash.substring(colonIdx + 1);
  const params: Record<string, string> = {};
  for (const part of queryStr.split(PlaceTokens.PARAMETERS_SEPERATOR)) {
    if (!part) continue;
    const sepIdx = part.indexOf(PlaceTokens.PAIR_SEPERATOR);
    if (sepIdx < 0) {
      params[part] = '';
    } else {
      params[part.substring(0, sepIdx)] = part.substring(sepIdx + 1);
    }
  }
  return {token, params};
}

export default function openWizardEditorDialog(url: string): boolean {
  const parsed = parsePlaceUrl(url);
  if (!parsed) return false;
  const p = parsed.params;
  switch (parsed.token) {
    case PlaceTokens.FIELDS_SELECTOR_POPUP:
      Dialog.create({
        component: WizardFieldsSelectorDialog,
        componentProps: {
          pendingResponseId: p[PlaceTokens.PRM_PENDING_RESPONSE_ID],
          entityType: p[PlaceTokens.PRM_ENTITY_TYPE],
          isFromReportingEntity: p[PlaceTokens.PRM_IS_FROM_REPORTING_ENTITY] === 'true',
          dataSource1: p[PlaceTokens.PRM_DATA_SOURCE_1],
          dataSource2: p[PlaceTokens.PRM_DATA_SOURCE_2],
          dataSource3: p[PlaceTokens.PRM_DATA_SOURCE_3],
          dataSource4: p[PlaceTokens.PRM_DATA_SOURCE_4],
          dataSource5: p[PlaceTokens.PRM_DATA_SOURCE_5],
        },
      });
      return true;
    case PlaceTokens.REPORT_EXPRESSION_EDITOR:
      Dialog.create({
        component: ReportExpressionEditorDialog,
        componentProps: {
          pendingResponseId: p[PlaceTokens.PRM_PENDING_RESPONSE_ID],
          entityType: p[PlaceTokens.PRM_ENTITY_TYPE],
          screenType: p[PlaceTokens.PRM_SCREEN_TYPE] || 'Normal',
          fieldTitle: p[PlaceTokens.PRM_FIELD_TITLE],
          dataSource1: p[PlaceTokens.PRM_DATA_SOURCE_1],
          dataSource2: p[PlaceTokens.PRM_DATA_SOURCE_2],
          dataSource3: p[PlaceTokens.PRM_DATA_SOURCE_3],
          dataSource4: p[PlaceTokens.PRM_DATA_SOURCE_4],
          dataSource5: p[PlaceTokens.PRM_DATA_SOURCE_5],
        },
      });
      return true;
    case PlaceTokens.REPORT_UNION_HANDLING_EDITOR:
      Dialog.create({
        component: ReportUnionHandlingEditorDialog,
        componentProps: {
          pendingResponseId: p[PlaceTokens.PRM_PENDING_RESPONSE_ID],
          entityType: p[PlaceTokens.PRM_ENTITY_TYPE],
          fieldTitle: p[PlaceTokens.PRM_FIELD_TITLE],
        },
      });
      return true;
    default:
      return false;
  }
}
